
webpack.register(
    'layouts/pages/latest/latest',
    function() {
        return import('layouts/pages/latest/latest');
    },
    true
);